import { hubApi, withAuthHeader } from '@/lib/backend/api';
import { getAuthToken } from '@/lib/firebase/token';
import { Market } from '@addmile/backend-client';
import { useMutation } from '@tanstack/react-query';

export const useChangeTariffLTV = () => {
  return useMutation({
    mutationFn: async ({
      tariffId,
      market,
      newLtv,
    }: {
      tariffId: number;
      market: Market;
      newLtv: string;
    }) => {
      const token = await getAuthToken();
      return hubApi.upsertTariffLTVHub(tariffId, { market, amount: newLtv }, withAuthHeader(token));
    },
  });
};
